import { jsxs as n, jsx as r, Fragment as k } from "react/jsx-runtime";
import { Popover as h } from "radix-ui";
import { Icon as x } from "../Vivid/Icon.js";
import { Checkbox as L } from "../Vivid/Checkbox.js";
import { c as b } from "../index-Cu0xwYjD.js";
import p from "react";
const $ = "_trigger_22h04_1", I = "_reset_22h04_25", P = "_hasResetButton_22h04_50", w = "_triggerLabel_22h04_55", F = "_content_22h04_78", j = "_scaleIn_22h04_1", y = "_disabled_22h04_89", M = "_items_22h04_94", R = "_item_22h04_94", T = "_footerSeparator_22h04_129", D = "_footerButton_22h04_137", t = {
  trigger: $,
  reset: I,
  hasResetButton: P,
  triggerLabel: w,
  content: F,
  scaleIn: j,
  disabled: y,
  items: M,
  item: R,
  footerSeparator: T,
  footerButton: D
}, V = p.createContext({
  close: () => {
  }
}), K = ({
  disabled: g,
  triggerLabel: S,
  options: s,
  selectedOptions: a,
  onOpenChange: m,
  defaultOpen: N = !1,
  onOptionClick: d,
  onReset: c,
  footerAction: o
}) => {
  const [B, v] = p.useState(N), i = (e) => {
    v(e), m == null || m(e);
  }, C = `${S}: ${a.length === s.length ? "All" : a.length === 1 ? a[0].label : `${a.length} selected`}`, u = c && a.length !== s.length;
  return /* @__PURE__ */ n(h.Root, { open: B, onOpenChange: i, children: [
    /* @__PURE__ */ r(h.Trigger, { asChild: !0, children: /* @__PURE__ */ n(
      "button",
      {
        className: b(
          t.trigger,
          u && t.hasResetButton
        ),
        children: [
          /* @__PURE__ */ r("div", { className: t.triggerLabel, children: C }),
          u && /* @__PURE__ */ r(
            "div",
            {
              className: t.reset,
              onClick: (e) => {
                e.stopPropagation(), c == null || c(), i(!1);
              },
              children: x.close
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ r(h.Portal, { children: /* @__PURE__ */ r(
      h.Content,
      {
        align: "start",
        className: b(t.content, g && t.disabled),
        sideOffset: 5,
        onOpenAutoFocus: (e) => e.preventDefault(),
        children: /* @__PURE__ */ r(
          V.Provider,
          {
            value: { close: () => i(!1) },
            children: /* @__PURE__ */ n("div", { className: t.container, children: [
              /* @__PURE__ */ r("div", { className: t.items, children: s.map((e, f) => /* @__PURE__ */ r(
                L,
                {
                  className: t.item,
                  id: f.toString(),
                  checked: a.map((l) => l.param).includes(e.param),
                  option: e,
                  label: e.label,
                  disabled: g,
                  onOnlyClick: () => {
                    const l = [e];
                    d({
                      selectedOptions: l,
                      allOptionsSelected: l.length === s.length
                    }), i(!1);
                  },
                  onValueChange: () => {
                    const l = a.map((_) => _.param).includes(e.param) ? (
                      // If it is, remove it
                      a.filter(
                        (_) => _.param !== e.param
                      )
                    ) : (
                      // If it isn't, add it
                      [...a, e]
                    );
                    d({
                      selectedOptions: l,
                      allOptionsSelected: l.length === s.length
                    });
                  }
                },
                f.toString()
              )) }),
              o && /* @__PURE__ */ n(k, { children: [
                /* @__PURE__ */ r("span", { className: t.footerSeparator }),
                /* @__PURE__ */ n(
                  "button",
                  {
                    onClick: o.onClick,
                    className: t.footerButton,
                    children: [
                      o.icon,
                      " ",
                      o.label
                    ]
                  }
                )
              ] })
            ] })
          }
        )
      }
    ) })
  ] });
};
export {
  K as FilterMenu
};
